import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import { findAll } from './api-nota-bimestre-tipo';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import { setNotaBimestreTipo } from './actions/actions';

const useStyles = makeStyles({
    paper: {
        marginTop: '20px'
    },
    title: {
        paddingTop: '20px;',
        margin: '20px'
    },
    novoRegistro: {
        marginTop: '30px',
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});


export default function NotaBimestreTipoTable() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [notasBimestreTipo, setNotasBimestreTipo] = useState([]);

    useEffect(() => {
        findAll().then((data) => {
            if (data) {
                setNotasBimestreTipo(data);
            }
        })
    }, []);



    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Descrição</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {notasBimestreTipo.map((notaBimestreTipo) => (
                            <TableRow key={notaBimestreTipo.codigo}>
                                <TableCell>{notaBimestreTipo.descricao}</TableCell>
                                <TableCell>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            dispatch(setNotaBimestreTipo(notaBimestreTipo));
                                        }}
                                        className={classes.submit}>
                                        Selecionar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Container>

        </div>
    );
}